module.exports = __webpack_public_path__ + "media/images/gli-cf-ae8c992b86f71462d9e61a6208c6493c.png";